import { _t } from "../../services/TranslationService.js";

export function getSingleColumnModule(match, request, classDescription, hasSpecialValue) {
  return `<div class="singleColumnModule bettingBtn ${match.nr_of_columns == '1' ? 'fullWidthColumn' : classDescription} ${match.id}${
    hasSpecialValue ? "-span" : ``
  } ${match.id}-coef" match-market-option="${match.market_option}" match-market="${match.market}" match-home-name="${match.home_team}" match-away-name="${match.away_team}" match-odd="${Math.floor((parseFloat(match.odd) + Number.EPSILON) * 100) / 100}" game-id="${request.id}" bet-id="${match.id}">
    ${getInsideSingleColumn(match.market_option, match.odd, match.special_value, hasSpecialValue)}
  </div>`;
}

export function getInsideSingleColumn(market_option, odd, special_value, hasSpecialValue) {
  return ` ${
    hasSpecialValue
      ? ""
      : `<span>${_t(market_option)}</span>`
  }
  <span>${(Math.floor((parseFloat(odd) + Number.EPSILON) * 100) / 100).toFixed(2)}</span>`;
}
